import { ReactNode, useEffect } from 'react';
import { InterfaceButton, InterfaceLink, Link } from '@tiendanube/components';
import useTopBar from 'App/components/Topbar/useTopBar';
import BackNavigation from 'commons/components/BackNavigation';
import { useResponsive } from 'commons/components/Responsive';

import './HeaderTop.scss';

export interface HeaderTopProps {
  navigation?: Pick<InterfaceButton, 'children' | 'onClick'>;
  mainAction?: Pick<
    InterfaceLink,
    'appearance' | 'children' | 'onClick' | 'icon' | 'spinner' | 'disabled'
  >;
  actions?: ReactNode;
  showAllways?: boolean;
}

function HeaderTop({
  navigation,
  mainAction,
  actions,
  showAllways = false,
}: Readonly<HeaderTopProps>) {
  const { isMobile } = useResponsive();
  const { setHeaderNavigation } = useTopBar();

  useEffect(() => {
    !showAllways && setHeaderNavigation(navigation);
  }, [navigation, setHeaderNavigation, showAllways]);

  if (!(isMobile || showAllways)) return null;

  const renderBackNavigation = navigation && (
    <BackNavigation onClick={navigation.onClick}>
      {navigation.children}
    </BackNavigation>
  );

  const renderMainAction = mainAction && (
    <Link
      appearance={mainAction.appearance}
      icon={mainAction.icon}
      onClick={mainAction.onClick}
      spinner={mainAction.spinner}
      disabled={mainAction.disabled}
    >
      {mainAction.children}
    </Link>
  );

  return (
    <div className="stratus--page-mobile-navbar">
      {renderBackNavigation}
      <div className="stratus--page-mobile-navbar__toolbar">
        {renderMainAction}
        {actions}
      </div>
    </div>
  );
}

export default HeaderTop;
